import { render } from "./CreateCollectionPopup.vue?vue&type=template&id=744c1f5f&scoped=true"
import script from "./CreateCollectionPopup.vue?vue&type=script&lang=js"
export * from "./CreateCollectionPopup.vue?vue&type=script&lang=js"

import "./CreateCollectionPopup.vue?vue&type=style&index=0&id=744c1f5f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-744c1f5f"]])

export default __exports__